
import React from 'react';

import {Avatar, Box, Skeleton, Typography} from "@mui/material";
import { Person as PersonIcon } from '@mui/icons-material';
import {useDiscordUser} from "../../hooks/useDiscordUser";

interface DiscordHeaderProps {
    id: string;
}

export const DiscordHeader: React.FC<DiscordHeaderProps> = ({
    id
}) => {

    const {
        user,
        isLoading
    } =  useDiscordUser(id);

    const avatar = user && user.avatar && `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`;

    return <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Avatar sx={{ width: 24, height: 24, mr: 1 }} src={avatar}>
            <PersonIcon fontSize="small"></PersonIcon>
        </Avatar>
        <Typography variant="subtitle2" fontWeight="bold">
            {isLoading ? (
                <Skeleton width={80} height={20} />
            ) : (
                user!.username
            )}
        </Typography>
    </Box>

}